import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ResetPasswordPage.css';

const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch('https://mykaddle-api.onrender.com/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: password })
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('Password reset successful! Redirecting to login...');
        setTimeout(() => navigate('/auth'), 3000);
      } else {
        setMessage(data.message || 'Reset failed');
      }
    } catch (err) {
      setMessage('Server error');
    }

    setLoading(false);
  };

  return (
    <div className="reset-container">
      <div className="reset-form">
        <h2 className="reset-header">Change your Password</h2>
        <p className="reset-subtitle">Enter your new password below</p>

        <form onSubmit={handleSubmit} className="reset-input-box">
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="reset-input"
            />
            <span className="toggle-password" onClick={togglePassword}>
              {showPassword ? "Hide" : "Show"}
            </span>
          </div>

          <div className="password-wrapper">
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="reset-input"
            />
            <span className="toggle-password" onClick={toggleConfirmPassword}>
              {showConfirmPassword ? "Hide" : "Show"}
            </span>
          </div>

          {message && (
            <p className={`reset-message ${message.includes('successful') ? 'success' : 'error'}`}>
              {message}
            </p>
          )}

          <button 
            type="submit" 
            disabled={loading} 
            className="reset-btn"
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;